module.exports = __webpack_public_path__ + "img/01.ba406c8c.png";